<template>
  <el-dialog
    title="预览"
    class="mid-dialog "
    :visible.sync="dialogVisible"
    v-dialogDrag
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
  >
    <div class="flex detail-w justify-center">
      <div class="float-left mx-auto" :class="data.isShowSidebar ? 'w-880px' : 'w-1180px'">
        <div class="border-1px border-[#ccc] py-20px">
          <div ref="columnDetail">
            <div class="px-50px">
              <div class="text-25px font-bold text-center leading-24px detail-info">
                {{ detailInfo.title }}
              </div>
              <div
                class="text-18px text-center mt-10px leading-24px detail-info"
                v-if="detailInfo.subtitle"
              >
                {{ detailInfo.subtitle }}
              </div>
              <div
                class="flex justify-center mt-10px text-12px !leading-18px text-hex-333 detail-info"
              >
                <div class="mr-15px text-center column-author">
                  作者：{{ data.author || detailInfo.author }}
                </div>
                <div class="mr-15px text-center">
                  部门：{{ data.deptSourceName || detailInfo.deptSourceName }}
                </div>
                <div class="text-center">
                  发布时间：
                  {{
                    detailInfo.editPublishTime
                      ? dayjs(detailInfo.editPublishTime).format('YYYY-MM-DD HH:mm:ss')
                      : ''
                  }}
                </div>
              </div>
            </div>
            <div class="border-top-1px border-color-ccc mt-15px mb-10px"></div>
            <div class="px-50px">
              <div class="ql-container ql-snow">
                <div v-if="isVideoColumn" class="w-full pb-30px">
                  <video
                    style="width: 80%;height:500px;"
                    class="mx-auto"
                    :src="videoSrc"
                    controls
                  ></video>
                </div>
                <div
                  v-else-if="
                    (!dataId && (!data.content || data.content === '<p><br></p>')) ||
                      !detailInfo.content ||
                      detailInfo.content === '<p><br></p>'
                  "
                >
                  <iframe
                    v-if="
                      (data.uploadNotification || detailInfo.uploadNotification) &&
                        (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0'
                    "
                    :src="`/lib/pdfjs/web/viewer.html?file=${pdfUrl}`"
                    frameborder="0"
                    class="w-full h-0px"
                    ref="pdfView"
                    @load="pdfViewOnload"
                  ></iframe>
                  <div
                    class="flex mt-15px"
                    v-if="
                      (data.attachFile || detailInfo.attachFile) &&
                        (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0'
                    "
                  >
                    <div>附件：</div>
                    <div class="flex-1">
                      <div v-for="(item, index) in attachFileList" :key="index">
                        <a
                          class="underline hyperlink-color mr-50px"
                          :href="item.attachFileDownloadUrl"
                          target="_blank"
                          >{{ item.attachFileName }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="ql-editor"
                    v-html="data.content || detailInfo.content"
                    ref="richText"
                  ></div>
                </div>
                <div v-else>
                  <div
                    class="ql-editor"
                    v-html="data.content || detailInfo.content"
                    ref="richText"
                  ></div>
                  <iframe
                    v-if="
                      (data.uploadNotification || detailInfo.uploadNotification) &&
                        (isTextColumn || isImageTextColumn) &&
                        column.categoryCode !== '0'
                    "
                    :src="`/lib/pdfjs/web/viewer.html?file=${pdfUrl}`"
                    frameborder="0"
                    class="w-full h-500px"
                    ref="pdfView"
                    @load="pdfViewOnload"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-30px flex px-50px"
            v-if="
              (isTextColumn || isImageTextColumn) &&
                column.categoryCode !== '0' &&
                ((detailInfo.attachFile &&
                  detailInfo.content &&
                  detailInfo.content !== '<p><br></p>') ||
                  (data.attachFile && data.content && data.content !== '<p><br></p>'))
            "
          >
            <div>
              附件：
            </div>
            <div class="flex-1">
              <div v-for="(item, index) in attachFileList" :key="index">
                <a
                  class="underline hyperlink-color mr-50px"
                  :href="item.attachFileDownloadUrl"
                  target="_blank"
                  >{{ item.attachFileName }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import { FileApi } from '@wiz-api/file-management'
import { informationPublishMap } from '../../../js/config'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目
const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const fileApi = new FileApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    isVideoColumn() {
      return this.type === columnVideoType
    },
    isTextColumn() {
      return this.type === columnTextType
    },
    isImageTextColumn() {
      return this.type === columnImgTextType
    },
    dataId() {
      return this.data.id
    },
    videoUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
    pdfUrl() {
      const fileId = this.data.uploadNotification || this.detailInfo.uploadNotification
      return encodeURIComponent(`${this.fileUrl}preview/${fileId}?contentType=application/pdf`)
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/`
    },
  },
  watch: {
    // dataId: {
    //   immediate: true,
    //   handler(val) {
    //     if (val) {
    //       const type = this.data.type || ''
    //       this.type = type * 1
    //       this.getColumnDetail(val, type * 1)
    //     }
    //   },
    // },
    dialogVisible(val) {
      if (val && this.dataId) {
        const type = this.data.type || ''
        this.type = type * 1
        this.getColumnDetail(this.dataId, type * 1)
      }
    },
  },
  data() {
    return {
      type: '',
      videoSrc: '',
      attachFileList: [], // 附件信息
      detailInfo: {}, // 详情
      column: {
        categoryCode: '0',
      },
      columnId: '',
    }
  },
  methods: {
    async getColumn() {
      const [err, res] = await columApi.getColumnDetail(this.columnId)
      if (!err) {
        this.column = res
      }
    },
    closeDialog(done) {
      this.dialogVisible = false
      this.attachFileList = []
    },
    pdfViewOnload() {
      const contentWindow = this.$refs.pdfView.contentWindow
      const contentDocument = contentWindow.document
      setTimeout(() => {
        const resetFunction = (e) => {
          if (e.pageNumber === contentWindow.PDFViewerApplication.pagesCount) {
            let maxWidth = contentDocument.body.offsetWidth
            _.forEach(contentDocument.getElementsByClassName('page'), (item) => {
              const actualWidth =
                item.offsetWidth / contentWindow.PDFViewerApplication.toolbar.pageScale
              if (actualWidth > maxWidth) {
                maxWidth = actualWidth
              }
            })
            contentWindow.PDFViewerApplication.eventBus.dispatch('scalechanged', {
              source: contentWindow.PDFViewerApplication.toolbar,
              value: _.round(contentDocument.body.offsetWidth / maxWidth, 2),
            })
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
            contentWindow.PDFViewerApplication.eventBus.off('textlayerrendered', resetFunction)
          }
        }
        contentWindow.PDFViewerApplication.eventBus.on('textlayerrendered', resetFunction)
      }, 100)
      // 调整pdf预览样式颜色与主题色一致
      contentDocument.body.style.backgroundColor = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundImage = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundImage = 'unset'
      contentDocument.getElementById('findbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('findbar').style.backgroundImage = 'unset'
      contentDocument.getElementById('secondaryToolbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('secondaryToolbar').style.backgroundImage = 'unset'
      const selectOptions = contentDocument.querySelectorAll(
        '.dropdownToolbarButton > select > option'
      )
      if (selectOptions) {
        selectOptions.forEach((item) => {
          item.style.backgroundColor = '#c11920'
        })
      }
      const timer = setInterval(() => {
        if (contentWindow.PDFViewerApplication.pdfDocument) {
          clearInterval(timer)
          this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
            .offsetHeight + 100}px`
          setTimeout(() => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }, 500)
          // 缩小
          contentDocument.getElementById('zoomIn').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 放大
          contentDocument.getElementById('zoomOut').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 缩放下拉切换
          contentDocument.getElementById('scaleSelect').onchange = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
        }
      }, 500)
      if (!this.detailInfo.isAllowDownload) {
        contentDocument.querySelector('.toolbarButton.download').style.display = 'none'
        contentDocument.querySelector('.toolbarButton.print').style.display = 'none'
      }
    },
    async getColumnDetail(id, type) {
      this.attachFileList = []
      let err
      let res
      // 文字栏目详情
      if (type === columnTextType) {
        ;[err, res] = await columnTableApi.getTextColumnTableDetail(id)
        if (!err) {
          this.columnId = res.columnId
          await this.getColumn()
          this.handleAttachFile(res)
        }
      }
      // 图文栏目详情
      if (type === columnImgTextType) {
        ;[err, res] = await columnTableApi.getImageColumnTableDetail(id)
        if (!err) {
          this.columnId = res.columnId
          await this.getColumn()
          this.handleAttachFile(res)
        }
      }
      // 视频栏目详情
      if (type === columnVideoType) {
        ;[err, res] = await columnTableApi.getVideoColumnTableDetail({ id })
        if (!err) {
          this.columnId = res.columnId
          res.videoSrc = `${this.videoUrl}${res.videoFile}/play-video`
          await this.getColumn()
          this.handleVideo(res.videoFile)
          this.handleAttachFile(res)
        }
      }
    },
    async handleAttachFile(res) {
      res.creationTime = dayjs(res.creationTime).format('YYYY-MM-DD HH:mm:ss')
      const attachFile = this.data?.attachFile || res.attachFile
      if (attachFile) {
        const fileIdList = attachFile.split(',')
        this.getAttachFileDownloadInfo(fileIdList, 0)
      }
      this.detailInfo = {
        ...res,
        content: this.replaceTableWidth(res.content),
      }
    },
    async getAttachFileDownloadInfo(fileIdList, index) {
      if (index >= fileIdList.length) return
      const fileId = fileIdList[index]
      if (!fileId) {
        this.getAttachFileDownloadInfo(fileIdList, index + 1)
        return
      }
      const [error, result] = await fileApi.get(fileId)
      if (!error) {
        const fileType = result.name
          .split('.')
          .at(-1)
          .toLowerCase()
        if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].includes(fileType)) {
          const contentType = {
            png: 'image/png',
            jpeg: 'image/jpeg',
            jpg: 'image/jpeg',
            mp4: 'video/mp4',
            pdf: 'application/pdf',
          }
          this.attachFileList.push({
            id: fileId,
            attachFileName: result.name,
            attachFileDownloadUrl: `/attachments-view?fileId=${fileId}&fileName=${result.name}&contentType=${contentType[fileType]}`,
          })
        } else {
          this.attachFileList.push({
            id: fileId,
            attachFileName: result.name,
            attachFileDownloadUrl: `${this.videoUrl}${fileId}/download`,
          })
        }
      }
      this.getAttachFileDownloadInfo(fileIdList, index + 1)
    },
    replaceTableWidth(htmlText) {
      if (!htmlText) {
        return ''
      }
      // 处理历史数据中段落起始为三个空格为两个空格
      if (htmlText.includes('<p>&nbsp; &nbsp; &nbsp;')) {
        htmlText = htmlText.replace('<p>&nbsp; &nbsp; &nbsp;', '<p>&nbsp; &nbsp;')
      }
      // 处理quill-better-table表格超出宽度问题
      if (htmlText.includes('quill-better-table')) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlText
        const colgroupList = tempDiv.querySelectorAll('.quill-better-table colgroup')
        colgroupList.forEach((item) => {
          item.remove()
        })
        htmlText = tempDiv.innerHTML
      }
      // 使用正则表达式匹配<table>标签
      const tableRegex = /<table\b[^>]*>/i
      const tableMatches = htmlText.match(tableRegex)
      if (tableMatches) {
        // 遍历匹配到的<table>标签
        _.forEach(tableMatches, (item) => {
          // 判断是否设置了width属性
          const widthRegex = /width=['"]([^'"]+)['"]/i
          const widthMatch = item.match(widthRegex)
          if (widthMatch) {
            const width = parseInt(widthMatch[[1]], 10)
            // 如果宽度超过780，则替换为780
            if (width > 780) {
              const newTableMatch = item.replace(widthMatch[0], 'width="780"')
              htmlText = htmlText.replace(item, newTableMatch)
              item = newTableMatch
            }
          }
          // 判断是否存在style属性，并且style中是否设置了width
          const styleRegex = /style=['"]([^'"]+)['"]/i
          const styleMatch = item.match(styleRegex)
          if (styleMatch) {
            const style = styleMatch[[1]]
            const newStyle = style.replace(
              /width:\s?[^;]+;/i,
              item.includes('quill-better-table') ? '' : 'table-layout: unset;'
            )
            const newTableMatch = item.replace(styleMatch[0], `style="${newStyle}"`)
            htmlText = htmlText.replace(item, newTableMatch)
          }
        })
      }
      return htmlText
    },
    handleVideo(videoFileId) {
      this.videoSrc = `${this.videoUrl}${videoFileId}/play-video`
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 1240px !important;
}
::v-deep .ql-container.ql-snow {
  border: none;
}
.ql-editor {
  padding: 12px 0;
}
</style>
